import { render, staticRenderFns } from "./complaintType.vue?vue&type=template&id=75349bb2&scoped=true&"
import script from "./complaintType.vue?vue&type=script&lang=js&"
export * from "./complaintType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75349bb2",
  null
  
)

export default component.exports